module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1600-4f746bbd042d99ab9f7578aa84efa4d2.jpg";